// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2Kzdm","content":"LayoutSettings_content__17CYQ"};